import {
    ICSSInJSStyle,
    pxToRem,
    SiteVariablesInput,
    ThemeInput,
  } from '@fluentui/react-northstar';
  
  const CommonTheme: ThemeInput = {
    componentStyles: {
      Button: {
        root: ({ props, variables }: ICSSInJSStyle) => ({
          ...(props.iconOnly && {
            ...(!props.inverted && {
              ':hover': {
                color: variables.primaryColorHover,
                background: variables.primaryBackgroundColorHover,
              },
            }),
          }),
        }),
      },
      ListItemMedia: {
        root: ({ props }: ICSSInJSStyle) => ({
          ...(props.important && {
            '::before': {
              top: pxToRem(22),
              width: pxToRem(4),
              height: pxToRem(4),
              borderRadius: '50%',
            },
          }),
        }),
      },
      Dropdown: {
        list: ({ props, variables }: ICSSInJSStyle) => ({
          maxHeight: '13.5rem',
          boxShadow: 'rgb(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.1rem',
          background: variables.primaryBackgroundColorHover,
          borderColor: variables.backgroundColor,
          borderWidth: '1px',
        }),
      },
    },
    componentVariables: {
      TableRow: (siteVariables: SiteVariablesInput) => ({
        backgroundHoverColor: siteVariables.colorScheme.brand.backgroundHover,
        hoverColor: siteVariables.colorScheme.brand.foreground4,
      }),
    },
  };
  
  export default CommonTheme;
  